export default __webpack_public_path__ + "9a5b4f863c019e32dbb3a9aafbf347f3.svg";